// @flow
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Icon from 'app/components/Icon';
import styles from './TopBarSocialIcons.styles';

class TopBarSocialIcons extends React.Component<Props> {

    constructor(props) {
      super(props);

      this.list = [
        {
          href: 'http://aparat.com/caffecinema',
          className: 'iconAparat',
          name: 'aparat'
        },
        {
          href: 'https://telegram.me/caffecinemacom',
          className: 'iconTelegram',
          name: 'telegram'
        },
        {
          href: 'http://instagram.com/caffecinemacom',
          className: 'iconInstagram',
          name: 'instagram'
        },
        {
          href: 'https://www.facebook.com/CaffeCinemaOfficial',
          className: 'iconFacebook',
          name: 'facebook'
        },
      ];
    }
    render() {
      const {classes} = this.props;
      return (
        <ul className={classes.list}>
          {this.list.map(item => {
            return (
              <li key={item.className} className={classes.item}>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={item.href}
                >
                <Icon
                  name={item.name}
                  className={classNames(classes[item.className], classes.itemIcon)}
                />
                </a>
              </li>
            );
          })}
        </ul>
      );
    }
}

const Component = withStyles(styles)(TopBarSocialIcons);
export {Component as TopBarSocialIcons};
export default Component;